<template>
  <div class="dev-landing-page">
    <div class="page-content container-lg">
      <h4 class="user-type">For developers</h4>
      <img src="@/assets/icons/dev_tools_300.png" alt="Developer tools" class="page-icon"/>
      <h1>Use our API to build new experiences</h1>
      <div class="page-text">
        The Tree Crossing API provides a secure, consistent way for authorized clients to access private family tree data regardless of the original database format. 
        Data access is controlled by the data owner.
        API access is granted to select partners who want to build new experiences that encourage families to find and learn more about their ancestors together.
      </div>
      <button type="button" class="btn btn-primary" @click="requestAccess">
        Request access to API
      </button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.dev-landing-page {
  flex-grow: 1;
  background-color: var(--page-bg-alt);
}

.user-type {
  margin: 0;
  color: var(--brand-primary);
  border: 2.5px solid var(--brand-primary);
  padding: 0.5rem 2rem;
  border-radius: 8px;
}

.page-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
  padding: 2rem 1rem;
}

.page-icon {
  width: 155px;
  height: 130px;
  margin-bottom: 2.5rem;
  margin-top: 1.5rem;
}

h1 {
  margin: 0;
  text-align: center;
  font-size: 2rem;

  @media (min-width: 768px) {
    font-size: 2.5rem;
  }
}

.page-text {
  max-width: 800px;
  padding: 0 1rem;
  text-align: center;

  @media (min-width: 768px) {
    font-size: 1.1rem;
    line-height: 1.8;
  }
}

button {
  @media (min-width: 768px) {
    height: 3rem;
    font-size: 1.1rem;
  }
}
</style>

<script lang="ts" setup>
import { useRouter } from 'vue-router'

const router = useRouter()

function requestAccess() {
  router.push({ path: '/contact', query: { subject: 'Request API access'} })
}  
</script>